export const brandPageTheme = {
    breakpoints: {
        xxl: 'screen and (min-width: 1920px)',
        xxxl: 'screen and (min-width: 2560px)',
    },
    breakpointsReverse: {
        xxl: 'screen and (max-width: 1919px)',
        xxxl: 'screen and (max-width: 2559px)',
    },
    numericBreakpoints: {
        xxl: 1920,
        xxxl: 2560,
    },
};

export const DPR_1 = 'dpr_1.0';
export const DPR_2 = 'dpr_2.0';

export const SCROLL_SPEED_MULTIPLIER = 100;
export const SCROLL_SPEED_INCREASE_MULTIPLIER = -1;
export const SCROLL_SPEED_DECREASE_MULTIPLIER = 1;

export const HEADER_HEIGHT = 80;
